import { render, staticRenderFns } from "./PrintPage.vue?vue&type=template&id=372b0928&scoped=true"
import script from "./PrintPage.vue?vue&type=script&lang=js"
export * from "./PrintPage.vue?vue&type=script&lang=js"
import style0 from "./PrintPage.vue?vue&type=style&index=0&id=372b0928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372b0928",
  null
  
)

export default component.exports